export const GET_CUSTOMER_INVOICES = "GET_CUSTOMER_INVOICES"
export const GET_CUSTOMER_INVOICES_SUCCESS = "GET_CUSTOMER_INVOICES_SUCCESS"
export const GET_CUSTOMER_INVOICES_FAIL = "GET_CUSTOMER_INVOICES_FAIL"

export const GET_CUSTOMER_INVOICE_DETAIL = "GET_CUSTOMER_INVOICE_DETAIL"
export const GET_CUSTOMER_INVOICE_DETAIL_SUCCESS = "GET_CUSTOMER_INVOICE_DETAIL_SUCCESS"
export const GET_CUSTOMER_INVOICE_DETAIL_FAIL = "GET_CUSTOMER_INVOICE_DETAIL_FAIL"

export const ADD_NEW_CUSTOMER_INVOICE = "ADD_NEW_CUSTOMER_INVOICE"
export const ADD_NEW_CUSTOMER_INVOICE_SUCCESS = "ADD_NEW_CUSTOMER_INVOICE_SUCCESS"
export const ADD_NEW_CUSTOMER_INVOICE_FAIL = "ADD_NEW_CUSTOMER_INVOICE_FAIL"

export const UPDATE_CUSTOMER_INVOICE = "UPDATE_CUSTOMER_INVOICE"
export const UPDATE_CUSTOMER_INVOICE_SUCCESS = "UPDATE_CUSTOMER_INVOICE_SUCCESS"
export const UPDATE_CUSTOMER_INVOICE_FAIL = "UPDATE_CUSTOMER_INVOICE_FAIL"

export const DELETE_CUSTOMER_INVOICE = "DELETE_CUSTOMER_INVOICE"
export const DELETE_CUSTOMER_INVOICE_SUCCESS = "DELETE_CUSTOMER_INVOICE_SUCCESS"
export const DELETE_CUSTOMER_INVOICE_FAIL = "DELETE_CUSTOMER_INVOICE_FAIL"

export const ADD_NEW_PAYMENT = "ADD_NEW_PAYMENT"
export const ADD_NEW_PAYMENT_SUCCESS = "ADD_NEW_PAYMENT_SUCCESS"
export const ADD_NEW_PAYMENT_FAIL = "ADD_NEW_PAYMENT_FAIL"
